import { title } from '../utils/style';
import { url } from '../utils/config';
import Table from '../reusable_components/Table';
import moment from "moment";

function CancelledAppointments() {

    const options = [
        {
            header: 'DATE',
            key: 'date',
            placeHolder: 'mm-dd-yyyy'
        },
        {
            header: 'TIME SLOT',
            key: 'time',
        },
        {
            header: 'Problem Description',
            key: 'problemDescription',
        },
        {
            header: 'VEHICLE INFO',
            render: (data) => { if (data['make']) return `${data['make']} - ${data['model']} - ${data['year']}` },
        },
    ]

    const excludeFilter = ['VEHICLE INFO']

    return (
        <div className="p-4">
            <div className={`${title} mb-4`}>Cancelled Appointments</div>

            <Table
                options={options}
                url={url + '/cancelled_appointments'}
                pagination
                noButton
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default CancelledAppointments;